export default "__VITE_ASSET__4ASdDaRW__"